
export interface IPlayerData {
    id: number;
    name: string;
    token: string;
    start: Date;
    protected: boolean;
    password: string;
    status: string;
    externalViewerUrl?: string;
}

export interface IPlayerHlsClientInfo {
    valid: boolean;
    url: string;
    clientId: string | null;
    segmentFirst: number;
    segmentDuration: number;
    start: Date;
    serverTotalTimeCurrent?: number;
    sequence: number;
}

export interface IPlayerControls {
  isPaused: boolean;
  isMuted: boolean;
  isLive: boolean;
  isFullscreen: boolean;
  overlayTimeout: number;
  volume: number;
  currentVolume: number;
  liveFinished: boolean;
}

export interface IPlayerAudioCommon {
  isMuted: boolean;
  volume: number;
  currentVolume: number;
}

export interface IPlayerTimetagData {
  tsStart: number;
  tsEnd: number;
  tsTag: number;
}
